module.exports = __webpack_public_path__ + "media/images/woman-success-871b1f547fc027f4a02cf08619742fca.svg";